import {createAction, props} from "@ngrx/store";
import {MessageCount} from "../../models/MessageCount";

export const UPDATE = '[MessageCount] Update';
export const REFRESH = '[MessageCount] Refresh';
export const update = createAction(UPDATE, props<{ messageCount: MessageCount[] }>());
export const refresh = createAction(REFRESH);
